import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import HomePageTotemBackground from '../assets/images/homePageTotemBackground.png';
import { useIntl } from 'react-intl';
import { SemiDonutChart } from './SemiDonutChart';
import { LanguageButtons } from "./LanguageButtons";

export const BodyHomePageTotem = ({ nedocsValue, history }) => {

    const intl = useIntl();

    return (
        <React.Fragment>
            <Container fluid="true" style={{
                backgroundColor: "#F5F5F5",
                backgroundImage: `url(${HomePageTotemBackground})`,
                backgroundPosition: "bottom center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            }}>
                <Row className="align-items-center justify-content-center"
                    style={{
                        color: "#ffffff",
                    }}>
                    <div style={{
                        fontSize: "290%",
                        fontWeight: "bold",
                        marginTop: "2%",
                    }}
                    >{intl.formatMessage({ id: 'homePageTotem.titoloPoliclinoTotem' })}
                    </div>
                </Row>
                <Row className="align-items-center justify-content-center">
                    <div style={{
                        fontSize: "200%",
                        fontWeight: "roboto-Regular",
                        color: "#ffffff",
                    }}>{intl.formatMessage({ id: 'homePageTotem.dipartimentoAccetazione' })}
                    </div>
                </Row>
                <Row className="align-items-center justify-content-center">
                    <div style={{
                        fontSize: "215%",
                        color: "#ffffff",
                        marginTop: "7%",
                    }}>{intl.formatMessage({ id: 'homePageTotem.statusProntoSoccorso' })}
                    </div>
                </Row>
                <Row className="align-items-center justify-content-center">
                    <div style={{
                        marginTop: "1%",

                    }}>
                        <Row
                            style={{
                                fontSize: "100%",
                                alignItems: "center",
                                marginBottom: "1em"
                            }}
                        >
                            <Col lg={3}>
                                <div style={{ width: "10em" }}>
                                    <SemiDonutChart percentage={nedocsValue > 0 ? nedocsValue : 0} />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Row>
                <Row className="align-items-center justify-content-center">
                    <div style={{
                        fontSize: "140%",
                        color: "#ffffff",
                    }}>{intl.formatMessage({ id: 'homePageTotem.indiceAffollamento' })}
                    </div>
                </Row>
                <Row className="align-items-center justify-content-center"
                    style={{
                        marginTop: "5%",
                    }}>
                    <div style={{
                        fontSize: "320%",
                        fontWeight: "bold",
                        color: "#ffffff",
                    }}>{intl.formatMessage({ id: 'homePageTotem.titoloBenvenutoTotem' })}
                    </div>
                </Row>
                <Row className="align-items-center justify-content-center">
                    <div style={{
                        fontSize: "270%",
                        marginTop: "1%",
                        marginBottom: "3%",
                        color: "#ffffff",
                    }}>{intl.formatMessage({ id: 'homePageTotem.sceltaLingua' })}
                    </div>
                </Row>
            </Container>
            <LanguageButtons history={history} />
        </React.Fragment>
    )
}